<template>
	<div class="flex flex-col relative">
		<div v-show="pickedDistrictId">
			<div class="flex justify-between items-center">
				<label class="form-label">Distrito:</label>
				<p class="text-xs text-gray-500" v-if="!required">Opcional</p>
			</div>

			<div class="border bg-white flex items-center gap-2 justify-between w-full pl-4 pr-2 py-2 border-black rounded-lg" 
				@click="resetDistrict">
				<div>
					<div class="font-bold">{{ pickedDistrict.name }}</div>
					<div class="text-xs text-gray-500">{{ pickedDistrict.province }} - {{ pickedDistrict.region }}</div>
				</div>
				<button type="button">
					<span class="hover:underline font-bold cursor-pointer text-wm-blue text-sm"
						@click="resetDistrict">
                    <!-- pencil icon -->
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="text-blue-300 size-6" viewBox="0 0 24 24">
                         <path fill="#93C5FD"
                             d="m7.43 15.92 1.26-3.16a4 4 0 0 1 .89-1.34L16.5 4.5a2.12 2.12 0 0 1 3 3l-6.92 6.92a4 4 0 0 1-1.34.88l-3.16 1.27a.5.5 0 0 1-.65-.65Z" />
                         <path fill="#93C5FD"
                             d="M5.5 7.75c0-.69.56-1.25 1.25-1.25H12A.75.75 0 0 0 12 5H6.75A2.75 2.75 0 0 0 4 7.75v9.5A2.75 2.75 0 0 0 6.75 20h9.5A2.75 2.75 0 0 0 19 17.25V12a.75.75 0 0 0-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5Z" />
                     </svg>
					</span>
				</button>
			</div>
		</div>

		<wm-input ref="input" v-show="pickedDistrictId == 0" label="Distrito" v-model="districtQuery"
			error-message="Campo requerido" :required="required" placeholder="ej. Miraflores" :isForm="isForm"
			@keydown="fetchDistricts" @focus="showResults = true" @blur="hideResults"></wm-input>

		<ul v-if="showResults && districtList.length"
			class="text-sm absolute z-10 w-full bg-white px-1 py-1 top-[4rem] border border-gray-300 rounded-md shadow divide-y max-h-64 overflow-auto">
			<li v-for="district in districtList" :key="district.id"
				class="group flex flex-col gap-1 py-1 px-2 hover:bg-wm-blue rounded-md hover:text-white cursor-pointer"
				@click="pickDistrict(district)">
				<span class="font-bold" v-html="highlightMatch(district.name, districtQuery)" </span>
					<div class="text-xs text-gray-500 group-hover:text-blue-100">
						{{ district.province }} - {{ district.region }}
					</div>
			</li>
		</ul>
		<ul v-else-if="showResults && !districtList.length"
			class="text-sm absolute z-10 w-full bg-white px-1 py-1 top-[4rem] border border-gray-300 rounded-md shadow divide-y max-h-48 overflow-auto">
			<li class="group flex flex-col gap-1 py-1 px-2 hover:bg-wm-blue rounded-md hover:text-white cursor-pointer"
				v-if="!searching">
				<span class="font-bold">No se encontraron resultados</span>
				<div class="text-xs text-gray-500">
					No se encontraron distritos que coincidan con "{{ districtQuery }}"
				</div>
			</li>
			<li class="group flex flex-col gap-1 py-1 px-2 hover:bg-wm-blue rounded-md hover:text-white cursor-pointer"
				v-else>
				<span class="font-bold">Buscando...</span>
				<div class="text-xs text-gray-500">
					Por favor espere
				</div>
			</li>
		</ul>
	</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import WmInput from './wm-input.vue';
import { fetchDistrict, queryDistricts } from '../requests/districts';
import Toast from '../toast';
import { District } from '../requests/types';



export default defineComponent({
	name: 'DistrictInput',
	components: { WmInput },
	props: {
		modelValue: { type: Number, default: 0 },
		isForm: { type: Boolean, default: false },
		required: { type: Boolean, default: true },
	},
	emits: ['update:modelValue'],
	data() {
		return {
			showResults: false,
			districtQuery: "",
			districtName: "",
			pickedDistrictId: 0,
			pickedDistrict: {
				id: 0,
				name: '',
				province: '',
				region: ''
			} as District,
			districtList: [] as District[],
			searching: false,
			searchTimeout: null as ReturnType<typeof setTimeout> | null,
		};
	},
	watch: {
		modelValue: function (newVal, oldVal) {
			if (newVal != oldVal){
				this.fetchDistrictData(newVal);
			}
			if (newVal == 0){
				// reset district
				this.pickedDistrict = {} as District;
				// this.$nextTick(() => (this.$refs.input?.querySelector("input") as HTMLElement)?.focus());
			}
		},
	},
	methods:{
		hideResults(){
			// wait a bit to be sure the click event is registered
			window.setTimeout(()=>{
				this.showResults = false
			}, 2000)
		},
		highlightMatch(str: string, query: string) {
			const regex = new RegExp(`(${query})`, 'gi');
			return str.replace(regex, '<span class="underline bg-yellow-300 rounded-sm">$1</span>');
		},
		pickDistrict(district: District){
			if (district.id == null){
				this.emitDistrictId(0);
				this.districtQuery = "";
				this.showResults = true;
				// TODO: focus on the input
				return;
			}

			this.districtId = district.id;
			this.showResults = false;
			this.emitDistrictId(district.id);
		},
		resetDistrict() {
			this.pickedDistrictId = 0;
			this.pickedDistrict = {} as District;
			this.districtQuery = '';
			this.emitDistrictId(0);
			this.focusInput();
		},
		focusInput(){
			this.$nextTick(() => {
				let wmInput = (this.$refs.input)
				wmInput?.$el.querySelector("input").focus();
			});
		},
		fetchDistricts() {
			if (!this.districtQuery) {
				this.showResults = false;
				return;
			}

			if (this.searchTimeout) {
				clearTimeout(this.searchTimeout);
			}
			this.districtList = [];
			this.searching = true;
			this.searchTimeout = setTimeout(() => {
				queryDistricts(this.districtQuery)
					.then(districts => {
						this.districtList = districts.slice(0, 20);
						this.showResults = true;
					})
					.catch(err => {
						console.error("Error: ", err);
						Toast.error("Error al buscar distritos, intente nuevamente.");
					}).finally(() => {
						this.searching = false;
					});
			}, 100);
		},
		emitDistrictId(id: number) {
			this.$emit('update:modelValue', id);
		},
		fetchDistrictData(id: number){
			if (id == 0 || id == null || id == undefined){return}
			fetchDistrict(id)
			.then(district => {
					this.pickedDistrictId = district.id;
					this.pickedDistrict = district;
					this.districtQuery = this.pickedDistrict.name;
					this.showResults = false;
				})
				.catch(err => {
					console.error("Error: ", err);
				})
		}
	},
	mounted(){
		// get district data passed via "prop"
		this.fetchDistrictData(this.modelValue);

		queryDistricts("")
			.then(districts => {
				this.districtList = districts.slice(0, 20);
			})
			.catch(err => {
				console.error("Error: ", err);
				Toast.error("Error al buscar distritos, intente nuevamente.");
			}).finally(() => {
				this.searching = false;
			});
	}
}
);
</script>
